import {action, observable, computed} from 'mobx';

class TimelineStore {
    @observable searchStr = '';
    @observable activeIndex = null;
    @observable cards = [];

    @computed get searchIndexes() {
        return this.cards.reduce((res, card, index) => {
            if (card.name.toLowerCase().includes(this.searchStr)) {
                res.push(index);
            }
            return res;
        }, []);
    }

    @action initCards = (cards) => {
        this.cards = cards;
    };

    @action setActiveIndex = (index) => {
        this.activeIndex = index;
    };

    @action setSearchStr = (val) => {
        this.searchStr = val.toLowerCase();
        this.setActiveIndex(val ? this.searchIndexes[0] : null);
    };

    @action resetSearch = () => {
        this.searchStr = '';
        this.activeIndex = null;
        this.cards = [];
    };

    get currentIndex() {
        const index = this.searchIndexes.findIndex(index => index === this.activeIndex);
        return index !== -1 ? index : null;
    }

    prevSearch = () => {
        const lastIndex = this.searchIndexes[this.searchIndexes.length - 1];
        this.setActiveIndex(this.searchIndexes[this.currentIndex - 1] || lastIndex);
    };

    nextSearch = () => {
        const firstIndex = this.searchIndexes[0];
        this.setActiveIndex(this.searchIndexes[this.currentIndex + 1] || firstIndex);
    }
}

const timelineStore = new TimelineStore();
export default timelineStore;
